import interceptors from "./interceptors/index";
import { SMU_SELECTED_MENU } from "../constants";

const fetchPromotions = (format, local, limit, p_categoria = null, p_ean = null, p_nombre_producto = null, p_seccion = null, p_linea = null, p_formato = null, p_tienda = null	) => {
  const params = { p_formato: format, p_local: local };
  if (p_categoria) params["p_categoria"] = p_categoria;
  if (p_ean) params["p_ean"] = p_ean;
  if (p_nombre_producto) params["p_nombre_producto"] = p_nombre_producto;
  if (p_seccion) params["p_seccion"] = p_seccion;
  if (p_linea) params["p_linea"] = p_linea;
  if (limit) params["limit"] = limit;
  if (p_formato) params["p_formato"] = p_formato;
  if (p_tienda) params["p_tienda"] = p_tienda;
  return interceptors({
    url: "/online-promocional/promotions",
    method: "GET",
    params,
  });
};

const fetchPromotionsWithFilters = (username, formatoImpresion, filters) => {
  
  const params = { username: username, formatoImpresion: formatoImpresion };
  for (const [key, value] of Object.entries(filters)) {
    if (value !== null && value !== undefined && value !== "" && !Array.isArray(value)) {
      params[key] = value;
    }
    if (Array.isArray(value) && value.length > 0) {
      const valueString = value.map(v => String(v)).join(',');
      params[key] = valueString;
    }
  }
  
  // Check if SMU_SELECTED_MENU exists and add category_menu if it does
  const savedSelectedMenu = localStorage.getItem(SMU_SELECTED_MENU);
  if (savedSelectedMenu) {
    try {
      const parsedMenu = JSON.parse(savedSelectedMenu);
      const menuId = parsedMenu?.id;
      if (menuId !== null && menuId !== undefined && menuId !== 0) {
        params.category_menu = menuId;
      }
    } catch (err) {
      // If parsing fails, continue without category_menu
      console.error("Error parsing SMU_SELECTED_MENU:", err);
    }
  }
  
  return interceptors({
    url: "/online-promocional/faldones",
    method: "GET",
    params,
  });
}

const downloadBinary = (promotionIds) => {
  return interceptors({
    url: "/online-promocional/download",
    responseType: 'arraybuffer',
    headers: {
      'Accept': 'application/octet-stream'
    },
    method: "POST",
    data: { promotionIds },
  });
};

const uploadFile = (file) => {
  return interceptors({
    url: "/online-promocional/upload-file",
    method: "POST",
    data: file,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const fetchDeletedProductsByPromo = (promo, local, negocio, nombreCampana) => {
  const params = { promo: promo, p_local: local, negocio: negocio, nombreCampana: nombreCampana };
  return interceptors({
    url: "/online-promocional/promotions",
    method: "GET",
    params,
  });
}

export { fetchPromotions, fetchPromotionsWithFilters, downloadBinary, uploadFile, fetchDeletedProductsByPromo };
